import { type VariantProps, cva } from 'class-variance-authority';
import type { ComponentProps, ElementType } from 'react';

import { cn } from '../lib/cn';

/**
 * 제목은 무채색 `fg`다 — 네이비는 링크·1차 행동·현재 위치에만 있다(D150).
 * 화면 제목 24/600 · 패널 18/600(display) · 카드 18/600 — D2 §4.2 · D150. 32는 홈 히어로 자리에만 남는다.
 */
export const titleVariants = cva('text-fg leading-ui', {
  variants: {
    level: {
      screen: 'font-display text-2xl font-semibold',
      /** 작업대 패널 · 화면 안 큰 구획 — 화면 제목(24)보다 한 단 아래 */
      panel: 'font-display text-lg font-semibold',
      card: 'text-lg font-semibold',
      /** 레일·목록 열 안의 작은 구획 이름 — 본문 크기(14)에 굵기만 올린다 */
      label: 'text-sm font-semibold',
    },
  },
  defaultVariants: { level: 'panel' },
});

const DEFAULT_TAG = {
  screen: 'h1',
  panel: 'h2',
  card: 'h3',
  label: 'h3',
} as const satisfies Record<NonNullable<VariantProps<typeof titleVariants>['level']>, ElementType>;

export interface TitleProps
  extends Omit<ComponentProps<'h2'>, 'ref'>, VariantProps<typeof titleVariants> {
  as?: 'h1' | 'h2' | 'h3' | 'h4';
}

export function Title({ className, level, as, ...props }: TitleProps) {
  const Tag = as ?? DEFAULT_TAG[level ?? 'panel'];

  return <Tag className={cn(titleVariants({ level }), className)} {...props} />;
}
